<div class="page-content container">
  <div class="page-header">
    <h1>
      <p>
        {{ translationManager.getTranslation('Увод') }}
      </p>
    </h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="content">
      <div class="page-part">
        <div class="form-element" *ngIf="state === viewState.Edit || state === viewState.Details">
          <label>{{ translationManager.getTranslation('Предмет захтева') }}</label>
          <div class="static">
            <span>{{ form.elements['requestSubject'].value | appvalue }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
